import classNames from 'classnames'

import {
  EMPTY_OBJECT,
  EMPTY_STRING,
  SYMBOL_HYPHEN,
} from '../../../constants/common'
import { FILE_SCOPE_CHAT } from '../../../constants/file'
import { useContentOverflow } from '../../../hooks'
import { toText } from '../../../utils/html'
import { Avatar } from '../../Avatar'
import { Counter } from '../../Counter'
import { EntityLabelList } from '../../Entity'
import { FileTableAttachments } from '../../File'
import { FloatingTooltip } from '../../Floating'
import { TableCellBase, TableEmptyCell } from '../../Table'
import Text from '../../Text'
import { toUserMultiValue, USER_MULTI_VALUE_AVATAR_SIZE } from '../../User'
import { isChatUnread } from '../Chat.utils'
import { ChatTableRowLastMessageDeleted } from '../ChatTableRowLastMessageDeleted'

import { FILES_VISIBLE_COUNT } from './ChatTableRowLastMessage.constants'

import * as styles from './ChatTableRowLastMessage.module.css'

function ChatTableRowLastMessage({
  className,
  item,
  scrollRef,
  unread,
  ...restProps
}) {
  const { overflow, setContentOverflowRef } = useContentOverflow()

  const {
    labels,
    last_message: lastMessage,
    unread_messages_count: unreadMessagesCount,
  } = item

  if (lastMessage && !lastMessage.deleted) {
    const { files, owner, text_preview: text } = lastMessage

    const parsedText = text ? toText(text) : EMPTY_STRING
    const { user } = toUserMultiValue(owner || EMPTY_OBJECT)

    return (
      <TableCellBase {...restProps} className={className}>
        <div className={styles.container}>
          <div className={styles.lastMessageContainer}>
            <div
              className={classNames(styles.lastMessage, {
                [styles.unread]: unread,
              })}
            >
              {user?.fullname ? (
                <div className={styles.lastMessageUser}>
                  <Avatar
                    className={styles.icon}
                    color={user.avatarColor}
                    size={USER_MULTI_VALUE_AVATAR_SIZE}
                    src={user.avatar}
                    text={user.fullname}
                  />
                  <div className={styles.nameWrapper}>
                    <FloatingTooltip
                      content={user.fullname}
                      disabled={!overflow}
                    >
                      <Text
                        className={styles.userName}
                        ref={setContentOverflowRef}
                        unread={unread}
                      >
                        {user.fullname}
                      </Text>
                    </FloatingTooltip>
                    <span className={styles.colon}>:</span>
                  </div>
                </div>
              ) : null}

              <FloatingTooltip content={parsedText}>
                <div className={styles.textContainer}>
                  <Text className={styles.text} unread={unread}>
                    {parsedText || SYMBOL_HYPHEN}
                  </Text>
                </div>
              </FloatingTooltip>
            </div>
            <EntityLabelList labels={labels} />
            {files?.length > 0 ? (
              <FileTableAttachments
                files={files}
                scope={FILE_SCOPE_CHAT}
                scrollRef={scrollRef}
                tooltipHintKey='ChatTable.LastMessageFilesItemTooltipHintKey'
                visibleCount={FILES_VISIBLE_COUNT}
              />
            ) : null}
          </div>
          {isChatUnread(item) ? (
            <Counter
              className={styles.lastMessageCounter}
              count={unreadMessagesCount}
            />
          ) : null}
        </div>
      </TableCellBase>
    )
  }

  return lastMessage ? (
    <ChatTableRowLastMessageDeleted {...restProps} unread={unread} />
  ) : (
    <TableEmptyCell {...restProps} />
  )
}

export default ChatTableRowLastMessage
